import * as Yup from 'yup'

const translatorValidationObject = {
  email: Yup.string()
    .email('Dirección de mail inválida')
    .required('Obligatorio'),
  password: Yup.string()
    .matches(
      /^(?=.*[A-Z])(?=.*\d).{8,}$/,
      'La contraseña debe tener al menos 8 caracteres, minúsculas, mayúsculas y números',
    )
    .required('Obligatorio'),
  passwordConfirm: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Las contraseñas no coinciden')
    .required('Obligatorio'),
}

const defaultValidationObject = {
  ...translatorValidationObject,
  firstName: Yup.string()
    .min(3, 'Debe tener al menos 3 caracteres')
    .max(40, 'Debe tener como mucho 40 caracteres')
    .required('Obligatorio'),
  lastName: Yup.string()
    .min(3, 'Debe tener al menos 3 caracteres')
    .max(40, 'Debe tener como mucho 40 caracteres')
    .required('Obligatorio'),
  telephone: Yup.string()
    .min(3, 'Debe tener al menos 3 números')
    .max(20, 'Debe tener como mucho 20 números')
    .matches(/\d+/, 'Debe ingresar un número')
    .notRequired(),
}

const clientValidationObject = {
  ...defaultValidationObject,
  companyName: Yup.string()
    .max(40, 'Debe tener como mucho 40 caracteres')
    .required('Obligatorio'),
  maxAccounts: Yup.number()
    .typeError('Debe ingresar un número')
    .min(1, 'El mínimo número de cuentas permitidas es 1')
    .max(50, 'El máximo número de cuentas permitidas es 50')
    .required('Obligatorio'),
  allowQR: Yup.boolean().notRequired(),
}

export const Roles = {
  Admin: {
    mainPath: 'admins',
    role: 'Admin',
    validation: Yup.object(defaultValidationObject),
  },
  Mediator: {
    mainPath: 'mediators',
    role: 'Mediator',
    validation: Yup.object(defaultValidationObject),
  },
  Client: {
    mainPath: 'clients',
    role: 'Client',
    validation: Yup.object(clientValidationObject),
  },
  Translator: {
    mainPath: 'translators',
    role: 'Translator',
    validation: Yup.object(translatorValidationObject),
    statuses: {
      Conectado: { value: 'Conectado', color: 'bg-green-500' },
      Desconectado: { value: 'Desconectado', color: 'bg-red-500' },
      'En Llamada': { value: 'En Llamada', color: 'bg-yellow-500' },
    },
  },
  Account: {
    mainPath: 'accounts',
    role: 'Account',
    validation: Yup.object(defaultValidationObject),
  },
}
